import { makeStyles } from '@mui/styles';

import { appColors, backgroundColors } from 'src/consts/app-config';
import theme from 'src/theme';

export const useStyles = makeStyles({
    '@global': {
        '@keyframes moveGradient': {
            '0%': {
                backgroundPosition: '0% 50%',
                opacity: 1,
            },
            '35%': {
                backgroundPosition: '100% 50%',
                opacity: 1,
            },
            '70%': {
                backgroundPosition: '0% 50%',
                opacity: 1,
            },
            '95%': {
                backgroundPosition: '0% 50%',
                opacity: 1,
            },
            '100%': {
                backgroundPosition: '0% 50%',
                opacity: 1,
            },
        },
    },

    playWithTimerWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },


    timerTextGreen: {
        color: '#00BA6C',
        fontWeight: 600,
        fontSize: 18,
        margin: 0,
        textAlign: 'center',
    },
    redirectText: {
        color: '#fff',
    },

    secondsText: {
        color: '#4CAF50',
        fontWeight: 600,
    },

    rakeBackModalWrapper: {
        position: 'relative',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('lg')]: {
            opacity: 0,
            // margin: '0 auto',
            width: 'fit-content',
            animationName: '$rakeBackModalWrapperMobile',
            animationDelay: '0.5s',
            animationIterationCount: '1',
            animationFillMode: 'forwards',
            animationDuration: '700ms',
            zIndex: 200,
            // position: 'absolute',
            // top: '5px',
            // right: '5px',
            '&.winner': {
                animationDelay: '1s',
            },
        },
        '@media screen and (min-width: 1025px)': {
            opacity: 0,
            width: 'fit-content',
            animationName: '$rakeBackModalWrapperMobile',
            animationDelay: '0.5s',
            animationIterationCount: '1',
            animationFillMode: 'forwards',
            animationDuration: '700ms',
            // position: 'absolute',
            // top: '15px',
            // right: '60px',
            // right: '15px',
            // margin: '0 auto',
            zIndex: 200,
            '&.winner': {
                animationDelay: '1s',
            },
        },
    },
    rakeBackFlexContainer: {
        [theme.breakpoints.down('lg')]: {
            width: 'fit-content',
            height: '42px',
            boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.25)',
            borderRadius: '8px',
            background: 'black',
            // margin: '0 auto',
            padding: '2px 5px',
            position: 'relative',
            '&:before': {
                display: 'block',
                content: "''",
                opacity: 1,
                position: 'absolute',
                zIndex: -1,
                top: '-2px',
                left: '-2px',
                bottom: '-2px',
                right: '-2px',
                borderRadius: '10px',
                backgroundSize: '200% 200%',
                background: `linear-gradient(
              60deg,
              hsl(156, 49%, 10%),
              hsl(180, 50%, 15%),
              hsl(180, 100%, 95%),
              hsl(180, 50%, 15%),
              hsl(156, 49%, 10%))`,
                animationName: 'moveGradient',
                animationIterationCount: 'infinite',
                animationFillMode: 'forwards',
                animationDuration: '3000ms',
                animationDelay: '0s',
            },
            '&.winner': {
                background: 'darkgoldenrod',
            },
        },
        '@media screen and (min-width: 1025px)': {
            width: 'fit-content',
            height: '56px',
            background: 'black',
            boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.25)',
            borderRadius: '8px',
            margin: '0 auto',
            padding: '0px 7px',
            position: 'relative',
            '&:before': {
                display: 'block',
                content: "''",
                opacity: 1,
                position: 'absolute',
                zIndex: -1,
                top: '-3px',
                left: '-3px',
                bottom: '-3px',
                right: '-3px',
                borderRadius: '10px',
                backgroundSize: '200% 200%',
                background: `linear-gradient(
              60deg,
              hsl(156, 49%, 10%),
              hsl(180, 50%, 15%),
              hsl(180, 100%, 95%),
              hsl(180, 50%, 15%),
              hsl(156, 49%, 10%))`,
                animationName: 'moveGradient',
                animationIterationCount: 'infinite',
                animationFillMode: 'forwards',
                animationDuration: '3000ms',
                animationDelay: '0s',
            },
            '&.winner': {
                background: 'darkgoldenrod',
            },
        },
    },

    '@keyframes rakeBackModalWrapperMobile': {
        '0%': {
            opacity: 0,
            transform: 'translateX(0%)',
        },
        '10%': {
            opacity: 0,
            transform: 'translateX(150%)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateX(0%)',
        },
    },

    rakeBackModal: {
        [theme.breakpoints.down('lg')]: {
            display: 'flex',
            height: '100%',
            justifyContent: 'space-between',
            width: '100%',
        },
        '@media screen and (min-width: 1025px)': {
            display: 'flex',
            height: '100%',
            justifyContent: 'space-between',
            width: '100%',
        },
    },
    rakeBackTextWrapper: {
        [theme.breakpoints.down('lg')]: {
            display: 'flex',
            fontSize: '20px',
            lineHeight: '20px',
            alignItems: 'center',
            textAlign: 'center',
            color: '#FFFFFF',
            textShadow: '0px 1.61975px 0px rgba(0, 0, 0, 0.15)',
            flex: 'none',
            order: 0,
            flexGrow: 0,
            margin: 0,
            width: '100%',
            justifyContent: 'space-between',
            gridGap: '5px',
        },
        '@media screen and (min-width: 1025px)': {
            display: 'flex',
            fontSize: '20px',
            lineHeight: '20px',
            alignItems: 'center',
            textAlign: 'center',
            color: '#FFFFFF',
            textShadow: '0px 1.61975px 0px rgba(0, 0, 0, 0.15)',
            flex: 'none',
            order: 0,
            flexGrow: 0,
            margin: 0,
            width: '100%',
            justifyContent: 'space-between',
            gridGap: '8px',
        },
    },
    rakeBackText: {
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('lg')]: {
            fontWeight: 400,
            margin: 0,
            fontSize: '15px',
        },
        '@media screen and (min-width: 1025px)': {
            fontWeight: 500,
            margin: 0,
            fontSize: '18px',
        },
    },

    timerText: {
        whiteSpace: 'nowrap',
        width: '18px',
        fontWeight: 600,
        margin: 0,
        fontSize: '15px',
    },

    rakeBackValue: {
        [theme.breakpoints.down('lg')]: {
            fontWeight: 700,
        },
        '@media screen and (min-width: 1025px)': {
            fontWeight: 700,
        },
    },
});
